// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// project imports
import ThemeOption from './theme';
import { ThemeMode } from 'config';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  // 1. FIXED: Added 'gold' and 'cyan' arrays required by your theme template
  const basePresetColors = {
    blue: ['#e6f7ff', '#bae7ff', '#91d5ff', '#69c0ff', '#40a9ff', '#1890ff', '#096dd9', '#0050b3', '#003a8c', '#00223a'],
    red: ['#fff1f0', '#ffccc7', '#ffa39e', '#ff7875', '#ff4d4f', '#f5222d', '#cf1322', '#a8071a', '#820014', '#5c0011'],
    green: ['#f6ffed', '#d9f7be', '#b7eb8f', '#95de64', '#73d13d', '#52c41a', '#389e0d', '#237804', '#135200', '#093b00'],
    orange: ['#fff7e6', '#ffd8bf', '#ffa940', '#ff851b', '#fa541c', '#d4380d', '#ad2102', '#871400', '#610b00', '#3b0400'],
    gold: ['#fffbe6', '#fff1b8', '#ffe58f', '#ffd666', '#ffc069', '#faad14', '#d48806', '#ad6800', '#874d00', '#613400'],
    cyan: ['#e6fffb', '#b5f5ec', '#87e8de', '#5cdbd3', '#36cfc9', '#13c2c2', '#08979c', '#006d75', '#00474f', '#002329']
  };

  const darkPresetColors = {
    blue: ['#111d2c', '#112a45', '#15395b', '#164c7e', '#1765ad', '#177ddc', '#3c9ae8', '#65b7f3', '#8dcffc', '#b7e3fe'],
    red: ['#2a1215', '#431418', '#58181c', '#791a1f', '#a61d24', '#f5222d', '#f74e54', '#f9797d', '#fb9fa2', '#fcc5c6'],
    green: ['#112115', '#11351c', '#144c23', '#166930', '#178c3d', '#52c41a', '#6fdb58', '#8ee675', '#acf293', '#cbfcb1'],
    orange: ['#271412', '#3c1813', '#511f17', '#6d2b1d', '#963f28', '#fa541c', '#fc7c52', '#fd9f7d', '#fec0a8', '#fee0d4'],
    gold: ['#2b2111', '#443111', '#594214', '#7c5e16', '#aa8317', '#faad14', '#fca822', '#fdbb42', '#fecf66', '#fee38f'],
    cyan: ['#112123', '#113537', '#144b4e', '#16676b', '#17898f', '#13c2c2', '#33d6d6', '#5ee3e3', '#89f0f0', '#b5fcfc']
  };

  // Assign the base object depending on Light or Dark system settings
  const colors = mode === ThemeMode.DARK ? { ...darkPresetColors } : { ...basePresetColors };

  let greyPrimary = [
    '#ffffff',
    '#fafafa',
    '#f5f5f5',
    '#f0f0f0',
    '#d9d9d9',
    '#bfbfbf',
    '#8c8c8c',
    '#595959',
    '#262626',
    '#141414',
    '#000000'
  ];
  let greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
  let greyConstant = ['#fafafb', '#e6ebf1'];

  if (mode === ThemeMode.DARK) {
    greyPrimary = ['#000000', '#141414', '#1e1e1e', '#595959', '#8c8c8c', '#bfbfbf', '#d9d9d9', '#f0f0f0', '#f5f5f5', '#fafafa', '#ffffff'];
    greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    greyConstant = ['#121212', '#d3d8db'];
  }
  
  // Combines grey shades array perfectly matching your previous object assignments
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      // 2. FIXED: Accessing keys like grey[900] instead of array index mappings
      text: {
        primary: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.87) : paletteColor.grey[700],
        secondary: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.45) : paletteColor.grey[500],
        disabled: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.1) : paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.05) : paletteColor.grey[200],
      background: {
        paper: mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0],
        default: paletteColor.grey.A50
      }
    },
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: {
            color: paletteColor.error.main,
            '&.Mui-error': {
              color: paletteColor.error.main
            }
          }
        }
      }
    }
  });
}
